import { Toaster } from 'react-hot-toast'
import React from 'react'

interface ICoreLayout {
  children: any
}

export const CoreLayout: React.FC<ICoreLayout> = ({ children }) => {
  return (
    <div
      id={'core-layout'}
      style={{ position: 'absolute', width: '100%', height: '100%', overflowX: 'hidden' }}
    >
      {children}
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            borderRadius: '0.5rem',
            background: '#1f2937',
            color: '#f9fafb',
          },
        }}
      />
    </div>
  )
}
